// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1tDVa","card":"Cards_card__3ryDb","infected":"Cards_infected__3_BcZ","recovered":"Cards_recovered__7sHaK","deaths":"Cards_deaths__30SYd"};